// GENERATED by scripts/generate-rules.mjs from
// app/src/main/res/values/strings.xml - do not edit.
export const RULES = Object.freeze([
  {
    "title": "Gioco dello zio di Marz",
    "blocks": [
      {
        "kind": "paragraph",
        "runs": [
          {
            "text": "Il Gioco dello zio di Marz è un incrocio tra Briscola, Tressette e Poker, da 3 a 8 giocatori (fino a 10 con un mazzo da 52).",
            "strong": false
          }
        ]
      },
      {
        "kind": "heading",
        "runs": [
          {
            "text": "TURNI E MANI",
            "strong": true
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "La partita è divisa in turni: nel 1° turno ogni giocatore ha 1 carta, nel 2° ne ha 2, e così via, fino a esaurire il mazzo.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Ogni turno ha tante mani quante sono le carte in mano.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "In ogni turno c'è una briscola, ossia il seme che comanda il gioco.",
            "strong": false
          }
        ]
      },
      {
        "kind": "heading",
        "runs": [
          {
            "text": "DICHIARAZIONI",
            "strong": true
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "All'inizio del turno ogni giocatore dichiara quante mani pensa di aggiudicarsi (da 0 al numero di carte che possiede).",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "L'ultimo a dichiarare non può scegliere il numero che renderebbe la somma di tutte le dichiarazioni uguale al numero di carte del turno.",
            "strong": false
          }
        ]
      },
      {
        "kind": "heading",
        "runs": [
          {
            "text": "COME SI GIOCA UNA CARTA",
            "strong": true
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Chi apre la mano può giocare qualsiasi carta.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Se hai il seme di apertura, devi rispondere con quel seme ",
            "strong": false
          },
          {
            "text": "oppure",
            "strong": true
          },
          {
            "text": " tagliare con una briscola (non sei obbligato a superare le carte già in tavola).",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Se ",
            "strong": false
          },
          {
            "text": "non",
            "strong": true
          },
          {
            "text": " hai il seme di apertura, sei libero: puoi giocare qualsiasi carta (una briscola o uno scarto).",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Vince la mano la briscola più alta; se non ci sono briscole, la carta più alta del seme di apertura.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Ordine di forza (mazzo da 40): Asso, 3, Re, Cavallo, Fante, 7, 6, 5, 4, 2.",
            "strong": false
          }
        ]
      },
      {
        "kind": "heading",
        "runs": [
          {
            "text": "PUNTEGGI",
            "strong": true
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Chi si aggiudica un numero di mani diverso da quello dichiarato non prende punti in quel turno.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Chi indovina esattamente prende (numero del turno + dichiarazione) punti.",
            "strong": false
          }
        ]
      },
      {
        "kind": "paragraph",
        "runs": [
          {
            "text": "Esempio: turno 5, dichiari 3 e fai 3 mani → +8 punti (5+3).",
            "strong": false
          }
        ]
      }
    ]
  },
  {
    "title": "Briscola",
    "blocks": [
      {
        "kind": "paragraph",
        "runs": [
          {
            "text": "La Briscola classica, da 2 a 6 giocatori con il mazzo italiano da 40 carte.",
            "strong": false
          }
        ]
      },
      {
        "kind": "heading",
        "runs": [
          {
            "text": "CARTE E PUNTI",
            "strong": true
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Valori: Asso 11, 3 vale 10, Re 4, Cavallo 3, Fante 2, tutte le altre 0. In tutto ",
            "strong": false
          },
          {
            "text": "120 punti",
            "strong": true
          },
          {
            "text": " per mano.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Ordine di forza: Asso, 3, Re, Cavallo, Fante, 7, 6, 5, 4, 2. Attenzione: ",
            "strong": false
          },
          {
            "text": "il 3 batte il Re",
            "strong": true
          },
          {
            "text": ".",
            "strong": false
          }
        ]
      },
      {
        "kind": "heading",
        "runs": [
          {
            "text": "LA BRISCOLA",
            "strong": true
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Prima di cominciare si scopre una carta sotto il mazzo: il suo seme è la briscola per tutta la mano, e quella carta è l'ultima che verrà pescata.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Una briscola batte qualsiasi carta di un altro seme",
            "strong": true
          },
          {
            "text": ": anche il 4 di briscola prende sull'Asso di un seme diverso.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Fra due briscole vince la più forte.",
            "strong": false
          }
        ]
      },
      {
        "kind": "heading",
        "runs": [
          {
            "text": "COME SI GIOCA",
            "strong": true
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Si tengono 3 carte in mano. ",
            "strong": false
          },
          {
            "text": "Non c'è obbligo di rispondere al seme",
            "strong": true
          },
          {
            "text": ": si può giocare qualunque carta.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Prende la mano la briscola più alta; se non ne è stata giocata nessuna, la carta più alta del seme di apertura. Una carta di un terzo seme è uno scarto e non prende mai.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Chi prende incassa i punti delle carte, pesca per primo e apre la mano successiva, finché il mazzo dura.",
            "strong": false
          }
        ]
      },
      {
        "kind": "heading",
        "runs": [
          {
            "text": "SQUADRE E PUNTEGGIO",
            "strong": true
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Con un numero pari di giocatori i posti si alternano fra due squadre; con un numero dispari si gioca ognuno per sé.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Se il mazzo non è divisibile per il numero di giocatori si scartano carte da 0 punti, così i 120 punti restano tutti in gioco.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "La partita dura tante mani quanti sono i giocatori, così ognuno dà le carte una volta: si somma il punteggio della squadra.",
            "strong": false
          }
        ]
      }
    ]
  },
  {
    "title": "Briscola a 5 (bastarda)",
    "blocks": [
      {
        "kind": "paragraph",
        "runs": [
          {
            "text": "La Briscola chiamata, o \"bastarda\": si gioca ",
            "strong": false
          },
          {
            "text": "solo in 5",
            "strong": true
          },
          {
            "text": ", con il mazzo italiano da 40. Otto carte a testa, tutto il mazzo va in mano e non si pesca mai.",
            "strong": false
          }
        ]
      },
      {
        "kind": "heading",
        "runs": [
          {
            "text": "PRESE E PUNTI",
            "strong": true
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Valori e ordine di forza sono quelli della Briscola: Asso 11, 3 vale 10, Re 4, Cavallo 3, Fante 2; ordine Asso, 3, Re, Cavallo, Fante, 7, 6, 5, 4, 2, per un totale di 120 punti.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "La briscola prende su qualsiasi carta di un altro seme",
            "strong": true
          },
          {
            "text": ", fra briscole vince la più forte, e non c'è obbligo di rispondere al seme.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Nessuna carta viene scoperta: ",
            "strong": false
          },
          {
            "text": "la briscola è il seme della carta chiamata",
            "strong": true
          },
          {
            "text": ". Chi vince l'asta la decide nel momento in cui chiama, e la carta chiamata è quindi sempre una briscola.",
            "strong": false
          }
        ]
      },
      {
        "kind": "heading",
        "runs": [
          {
            "text": "ASTA A CARTA",
            "strong": true
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Si dichiara la carta che si chiamerà, scendendo dall'Asso: Asso, 3, Re, Cavallo, Fante, 7, 6, 5, 4, 2. ",
            "strong": false
          },
          {
            "text": "Chiamare una carta più bassa è una dichiarazione più forte",
            "strong": true
          },
          {
            "text": ", perché è meno probabile che finisca nelle mani di un buon socio.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Arrivati al 2 non si può scendere oltre, e allora si rilancia sui punti: si resta sul 2 impegnandosi a fare più di 61 punti, da 62 fino a 120.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Chi vince l'asta sceglie il seme della carta chiamata, e quel seme è la briscola.",
            "strong": false
          }
        ]
      },
      {
        "kind": "heading",
        "runs": [
          {
            "text": "ASTA A PUNTI",
            "strong": true
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Si dichiara direttamente il punteggio che ci si impegna a fare, da 61 in su, rilanciando finché gli altri passano.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Chi vince l'asta sceglie liberamente ",
            "strong": false
          },
          {
            "text": "quale carta chiamare",
            "strong": true
          },
          {
            "text": ", prima il valore e poi il seme: anche qui quel seme diventa la briscola.",
            "strong": false
          }
        ]
      },
      {
        "kind": "heading",
        "runs": [
          {
            "text": "IL SOCIO SEGRETO",
            "strong": true
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Chi ha in mano la carta chiamata — che essendo del seme di briscola è una briscola — è il socio del chiamante, ma ",
            "strong": false
          },
          {
            "text": "nessuno lo dice",
            "strong": true
          },
          {
            "text": ": lo sa soltanto lui. Diventa pubblico nel momento in cui quella carta viene giocata.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Il chiamante può chiamare una carta che ha già in mano: in quel caso gioca 1 contro 4.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Se passano tutti, la mano si ridà.",
            "strong": false
          }
        ]
      },
      {
        "kind": "heading",
        "runs": [
          {
            "text": "PUNTEGGIO",
            "strong": true
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "A fine mano si sommano i punti presi dal chiamante e dal socio: se arrivano al punteggio dichiarato la chiamata è riuscita.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Riuscita: +2 al chiamante (+4 se giocava da solo), +1 al socio, −1 a ciascuno degli altri tre. Fallita: gli stessi valori con il segno cambiato.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "La partita dura 5 mani, una per giocatore.",
            "strong": false
          }
        ]
      }
    ]
  },
  {
    "title": "Briscola a 7 (bastarda)",
    "blocks": [
      {
        "kind": "paragraph",
        "runs": [
          {
            "text": "La Briscola chiamata in sette, col mazzo italiano da 40. Cinque carte a testa: sette giocatori non possono dividersi quaranta carte, così cinque carte da 0 punti escono dal mazzo e i ",
            "strong": false
          },
          {
            "text": "120 punti restano tutti in gioco",
            "strong": true
          },
          {
            "text": ". Tutto il mazzo va in mano e non si pesca mai.",
            "strong": false
          }
        ]
      },
      {
        "kind": "heading",
        "runs": [
          {
            "text": "DUE CARTE CHIAMATE",
            "strong": true
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Prese, valori e ordine di forza sono quelli della Briscola a 5: Asso 11, 3 vale 10, Re 4, Cavallo 3, Fante 2, e la briscola prende su qualsiasi carta di un altro seme.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "L'asta è su ",
            "strong": false
          },
          {
            "text": "un solo valore",
            "strong": true
          },
          {
            "text": ", ma chi la vince chiama ",
            "strong": false
          },
          {
            "text": "due carte",
            "strong": true
          },
          {
            "text": " di quel valore, nominando due semi: “i due Sei, coppe e spade”. ",
            "strong": false
          },
          {
            "text": "Il primo seme nominato è la briscola.",
            "strong": true
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Chi ha in mano una delle due carte chiamate è socio del chiamante, e ",
            "strong": false
          },
          {
            "text": "nessuno lo dice",
            "strong": true
          },
          {
            "text": ": lo si scopre quando quella carta viene giocata. Si gioca quindi ",
            "strong": false
          },
          {
            "text": "3 contro 4",
            "strong": true
          },
          {
            "text": ".",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Il chiamante può trovarsi in mano una delle carte chiamate, o entrambe: in quel caso i soci sono uno solo, o nessuno.",
            "strong": false
          }
        ]
      },
      {
        "kind": "heading",
        "runs": [
          {
            "text": "ASTA A CARTA",
            "strong": true
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Si scende dall'Asso al Cinque: Asso, 3, Re, Cavallo, Fante, 7, 6, 5. Come sempre ",
            "strong": false
          },
          {
            "text": "chiamare una carta più bassa è una dichiarazione più forte",
            "strong": true
          },
          {
            "text": ".",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Il 4 e il 2 ",
            "strong": false
          },
          {
            "text": "non si possono chiamare",
            "strong": true
          },
          {
            "text": ": sono le carte uscite dal mazzo per poter dare cinque carte a testa, e chiamarle non troverebbe nessuno.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Arrivati al Cinque non si scende oltre e si rilancia sui punti, da 62 fino a 120.",
            "strong": false
          }
        ]
      },
      {
        "kind": "heading",
        "runs": [
          {
            "text": "ASTA A PUNTI",
            "strong": true
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Si dichiara direttamente il punteggio, da 61 in su, e chi vince l'asta sceglie prima il valore da chiamare e poi i due semi.",
            "strong": false
          }
        ]
      },
      {
        "kind": "heading",
        "runs": [
          {
            "text": "PUNTEGGIO",
            "strong": true
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Ogni avversario vale un punto al chiamante e ogni socio gliene costa uno: con due soci il chiamante prende ",
            "strong": false
          },
          {
            "text": "+2",
            "strong": true
          },
          {
            "text": ", con un socio ",
            "strong": false
          },
          {
            "text": "+4",
            "strong": true
          },
          {
            "text": ", da solo contro sei ",
            "strong": false
          },
          {
            "text": "+6",
            "strong": true
          },
          {
            "text": ". Ogni socio prende +1, ogni avversario −1.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Se la chiamata fallisce gli stessi valori cambiano segno, e la mano resta sempre a somma zero.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "La partita dura 7 mani, una per giocatore.",
            "strong": false
          }
        ]
      }
    ]
  },
  {
    "title": "Tressette",
    "blocks": [
      {
        "kind": "paragraph",
        "runs": [
          {
            "text": "Il Tressette, in quattro a coppie, con il mazzo italiano da 40. Dieci carte a testa, tutto il mazzo in mano e niente pescate. I compagni siedono uno di fronte all'altro.",
            "strong": false
          }
        ]
      },
      {
        "kind": "heading",
        "runs": [
          {
            "text": "ORDINE DELLE CARTE",
            "strong": true
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "3, 2, Asso, Re, Cavallo, Fante, 7, 6, 5, 4",
            "strong": true
          },
          {
            "text": ". Il Tre è la carta più forte e il Due viene subito dopo: è l'ordine che dà il nome al gioco, e non è quello della Briscola.",
            "strong": false
          }
        ]
      },
      {
        "kind": "heading",
        "runs": [
          {
            "text": "COME SI GIOCA",
            "strong": true
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Non c'è briscola",
            "strong": true
          },
          {
            "text": ": nessun seme comanda sugli altri.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "È obbligatorio rispondere al seme",
            "strong": true
          },
          {
            "text": " di chi apre, se lo si ha in mano. Solo chi non ne ha più può giocare quello che vuole, ma quella carta non prende mai.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Prende la mano la carta più alta del seme di apertura. Chi prende apre la mano successiva.",
            "strong": false
          }
        ]
      },
      {
        "kind": "heading",
        "runs": [
          {
            "text": "PUNTEGGIO",
            "strong": true
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Si conta a ",
            "strong": false
          },
          {
            "text": "terzi di punto",
            "strong": true
          },
          {
            "text": ": l'Asso vale 3 terzi (un punto pieno), il 2, il 3, il Re, il Cavallo e il Fante un terzo ciascuno, il 4, 5, 6 e 7 niente.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "L'ultima presa della mano vale un punto intero.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "A fine mano i terzi di ogni coppia diventano punti e ",
            "strong": false
          },
          {
            "text": "il resto si butta via",
            "strong": true
          },
          {
            "text": ": 17 terzi fanno 5 punti, non 5 e rotti. In tutto una mano vale 11 punti.",
            "strong": false
          }
        ]
      },
      {
        "kind": "heading",
        "runs": [
          {
            "text": "ACCUSI",
            "strong": true
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Prima della prima carta si dichiara quello che si ha in mano: ",
            "strong": false
          },
          {
            "text": "tre carte uguali",
            "strong": true
          },
          {
            "text": " fra Assi, Due o Tre valgono 3 punti, ",
            "strong": false
          },
          {
            "text": "tutte e quattro",
            "strong": true
          },
          {
            "text": " ne valgono 4, e ",
            "strong": false
          },
          {
            "text": "Asso, Due e Tre dello stesso seme",
            "strong": true
          },
          {
            "text": " (napoletana) valgono 3 punti.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Gli accusi li annuncia il gioco per te, come farebbe chiunque al tavolo, e i punti vanno alla tua coppia.",
            "strong": false
          }
        ]
      },
      {
        "kind": "heading",
        "runs": [
          {
            "text": "DURATA",
            "strong": true
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "La partita dura tante mani quanti sono i giocatori, così ognuno dà le carte una volta, e si somma il punteggio della coppia.",
            "strong": false
          }
        ]
      }
    ]
  },
  {
    "title": "Scopa",
    "blocks": [
      {
        "kind": "paragraph",
        "runs": [
          {
            "text": "La Scopa, da 2 a 6 giocatori (in 4 e in 6 si gioca a coppie, con i compagni alternati), con il mazzo italiano da 40.",
            "strong": false
          }
        ]
      },
      {
        "kind": "heading",
        "runs": [
          {
            "text": "COME SI GIOCA",
            "strong": true
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Tre carte a testa e quattro scoperte sul tavolo. Quando tutti hanno finito le carte se ne danno altre tre, fino a esaurire il mazzo.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "A turno si gioca una carta: se sul tavolo c'è una carta dello ",
            "strong": false
          },
          {
            "text": "stesso valore",
            "strong": true
          },
          {
            "text": ", si è obbligati a prendere quella (se ce ne sono due uguali, si sceglie quale). Solo se non c'è nessuna carta uguale si può prendere un ",
            "strong": false
          },
          {
            "text": "gruppo di carte che sommano",
            "strong": true
          },
          {
            "text": " al valore giocato.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Se non si può prendere niente, la carta resta sul tavolo.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Valori: Asso 1, poi 2, 3, 4, 5, 6, 7, ",
            "strong": false
          },
          {
            "text": "Fante 8, Cavallo 9, Re 10",
            "strong": true
          },
          {
            "text": ".",
            "strong": false
          }
        ]
      },
      {
        "kind": "heading",
        "runs": [
          {
            "text": "LA SCOPA",
            "strong": true
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Se una presa lascia il tavolo vuoto è una ",
            "strong": false
          },
          {
            "text": "scopa",
            "strong": true
          },
          {
            "text": " e vale un punto. Non conta se è l'ultima carta della mano: non resterebbe nessuno a giocare sul tavolo vuoto.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Le carte rimaste sul tavolo alla fine vanno a chi ha preso per ultimo.",
            "strong": false
          }
        ]
      },
      {
        "kind": "heading",
        "runs": [
          {
            "text": "PUNTEGGIO",
            "strong": true
          }
        ]
      },
      {
        "kind": "paragraph",
        "runs": [
          {
            "text": "Ogni mano vale quattro punti più uno per ogni scopa:",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Carte",
            "strong": true
          },
          {
            "text": ": un punto a chi ne ha prese di più.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Denari",
            "strong": true
          },
          {
            "text": ": un punto a chi ha più carte di denari.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Settebello",
            "strong": true
          },
          {
            "text": ": un punto a chi ha preso il 7 di denari.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Primiera",
            "strong": true
          },
          {
            "text": ": un punto a chi ha la primiera più alta. Si prende la carta migliore di ogni seme e si sommano, con questa scala: 7 vale 21, 6 vale 18, Asso 16, 5 vale 15, 4 vale 14, 3 vale 13, 2 vale 12, le figure 10. Chi non ha nessuna carta di un seme non può vincerla.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "In caso di parità su carte, denari o primiera quel punto non lo prende nessuno.",
            "strong": false
          }
        ]
      },
      {
        "kind": "heading",
        "runs": [
          {
            "text": "DURATA",
            "strong": true
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "La partita dura tante mani quanti sono i giocatori, così ognuno dà le carte una volta.",
            "strong": false
          }
        ]
      }
    ]
  },
  {
    "title": "Scopone e scopone scientifico",
    "blocks": [
      {
        "kind": "paragraph",
        "runs": [
          {
            "text": "Lo Scopone: la Scopa ",
            "strong": false
          },
          {
            "text": "in quattro a coppie",
            "strong": true
          },
          {
            "text": ", con tutto il mazzo dato in una volta. Prese, valori e punteggio sono quelli della Scopa; quello che cambia è che ",
            "strong": false
          },
          {
            "text": "non si pesca mai",
            "strong": true
          },
          {
            "text": ", quindi dalla prima carta ogni carta che non è tua o sul tavolo è nelle mani degli altri tre.",
            "strong": false
          }
        ]
      },
      {
        "kind": "heading",
        "runs": [
          {
            "text": "DUE VARIANTI",
            "strong": true
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Scopone",
            "strong": true
          },
          {
            "text": ": nove carte a testa e quattro scoperte sul tavolo.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Scopone scientifico",
            "strong": true
          },
          {
            "text": ": dieci carte a testa e ",
            "strong": false
          },
          {
            "text": "il tavolo vuoto",
            "strong": true
          },
          {
            "text": ". La prima carta della mano non può prendere niente, e tutto quello che finisce sul tavolo ce l'ha messo qualcuno.",
            "strong": false
          }
        ]
      },
      {
        "kind": "heading",
        "runs": [
          {
            "text": "COME SI GIOCA",
            "strong": true
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "I compagni siedono uno di fronte all'altro. ",
            "strong": false
          },
          {
            "text": "Prendere è obbligatorio",
            "strong": true
          },
          {
            "text": ": se sul tavolo c'è una carta dello stesso valore si prende quella, e solo se non c'è si può prendere un gruppo di carte che sommano al valore giocato.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Valori: Asso 1, poi 2, 3, 4, 5, 6, 7, ",
            "strong": false
          },
          {
            "text": "Fante 8, Cavallo 9, Re 10",
            "strong": true
          },
          {
            "text": ".",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Le carte rimaste sul tavolo alla fine vanno a chi ha preso per ultimo, e la scopa fatta con l'ultima carta della mano non conta.",
            "strong": false
          }
        ]
      },
      {
        "kind": "heading",
        "runs": [
          {
            "text": "PUNTEGGIO",
            "strong": true
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Come nella Scopa: ",
            "strong": false
          },
          {
            "text": "carte",
            "strong": true
          },
          {
            "text": ", ",
            "strong": false
          },
          {
            "text": "denari",
            "strong": true
          },
          {
            "text": ", ",
            "strong": false
          },
          {
            "text": "settebello",
            "strong": true
          },
          {
            "text": " e ",
            "strong": false
          },
          {
            "text": "primiera",
            "strong": true
          },
          {
            "text": ", più un punto per ogni scopa. In caso di parità quel punto non lo prende nessuno.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "La partita dura 4 mani, una per giocatore, e si somma il punteggio della coppia.",
            "strong": false
          }
        ]
      }
    ]
  },
  {
    "title": "Cuori (hearts)",
    "blocks": [
      {
        "kind": "paragraph",
        "runs": [
          {
            "text": "Cuori (hearts), in quattro e ",
            "strong": false
          },
          {
            "text": "ognuno per sé",
            "strong": true
          },
          {
            "text": ", col mazzo francese da 52. Tredici carte a testa, tutto il mazzo in mano e niente pescate. È l'unico gioco qui in cui i punti sono ",
            "strong": false
          },
          {
            "text": "penalità",
            "strong": true
          },
          {
            "text": ": vince chi ne prende meno.",
            "strong": false
          }
        ]
      },
      {
        "kind": "heading",
        "runs": [
          {
            "text": "CARTE E PENALITÀ",
            "strong": true
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Ordine di forza: ",
            "strong": false
          },
          {
            "text": "Asso, King, Queen, Jack, 10, 9, 8, 7, 6, 5, 4, 3, 2",
            "strong": true
          },
          {
            "text": ". Attenzione: qui ",
            "strong": false
          },
          {
            "text": "l'Asso è la carta più alta",
            "strong": true
          },
          {
            "text": ", non come nei giochi italiani.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Ogni carta di ",
            "strong": false
          },
          {
            "text": "cuori costa 1 punto",
            "strong": true
          },
          {
            "text": " e la ",
            "strong": false
          },
          {
            "text": "Queen di picche ne costa 13",
            "strong": true
          },
          {
            "text": ": in tutto 26 penalità per mano.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Non c'è briscola",
            "strong": true
          },
          {
            "text": ": prende la carta più alta del seme di apertura, e ",
            "strong": false
          },
          {
            "text": "è obbligatorio rispondere al seme",
            "strong": true
          },
          {
            "text": " se lo si ha in mano.",
            "strong": false
          }
        ]
      },
      {
        "kind": "heading",
        "runs": [
          {
            "text": "IL PASSAGGIO",
            "strong": true
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Prima della prima carta ognuno dà ",
            "strong": false
          },
          {
            "text": "tre carte",
            "strong": true
          },
          {
            "text": " a un altro giocatore: nella prima mano a sinistra, nella seconda a destra, nella terza al giocatore di fronte, nella quarta ",
            "strong": false
          },
          {
            "text": "non si passa niente",
            "strong": true
          },
          {
            "text": ".",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Si scelgono una alla volta, e si vedono solo le tre che si riceve.",
            "strong": false
          }
        ]
      },
      {
        "kind": "heading",
        "runs": [
          {
            "text": "COME SI GIOCA",
            "strong": true
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Apre la mano chi ha il ",
            "strong": false
          },
          {
            "text": "2 di fiori",
            "strong": true
          },
          {
            "text": ", e deve giocare quella carta.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Nella ",
            "strong": false
          },
          {
            "text": "prima presa",
            "strong": true
          },
          {
            "text": " non si possono giocare cuori né la Queen di picche, a meno di non avere nient'altro.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Non si può ",
            "strong": false
          },
          {
            "text": "aprire",
            "strong": true
          },
          {
            "text": " a cuori finché un cuori non è stato giocato su un altro seme: si dice che i cuori sono ",
            "strong": false
          },
          {
            "text": "spezzati",
            "strong": true
          },
          {
            "text": ". Chi ha in mano solo cuori può comunque aprirci.",
            "strong": false
          }
        ]
      },
      {
        "kind": "heading",
        "runs": [
          {
            "text": "PUNTEGGIO",
            "strong": true
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "A fine mano ognuno si ",
            "strong": false
          },
          {
            "text": "sottrae",
            "strong": true
          },
          {
            "text": " le penalità prese, quindi i punteggi sono negativi e vince chi è più vicino a zero.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Chi prende ",
            "strong": false
          },
          {
            "text": "tutte e 26",
            "strong": true
          },
          {
            "text": " le penalità fa il cappotto (",
            "strong": false
          },
          {
            "text": "shoot the moon",
            "strong": true
          },
          {
            "text": "): non paga niente e sono gli altri tre a pagare 26 ciascuno. È l'unico motivo per andare a cercare i punti.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "La partita dura 4 mani, una per giocatore, che sono esattamente i quattro modi di passare le carte.",
            "strong": false
          }
        ]
      }
    ]
  },
  {
    "title": "La vecia",
    "blocks": [
      {
        "kind": "paragraph",
        "runs": [
          {
            "text": "La vecia, da 3 a 6 giocatori (fino a 8 con il mazzo da 52), con le carte trevisane. Non ci sono prese né punti da contare: qui si perde e basta, e si perde in uno solo.",
            "strong": false
          }
        ]
      },
      {
        "kind": "heading",
        "runs": [
          {
            "text": "LA VECIA",
            "strong": true
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Prima di dare le carte ",
            "strong": false
          },
          {
            "text": "un Fante esce dal mazzo",
            "strong": true
          },
          {
            "text": ". Il Fante rimasto senza il suo compagno è ",
            "strong": false
          },
          {
            "text": "la vecia",
            "strong": true
          },
          {
            "text": ": è l'unica carta che non potrà mai andarsene in coppia, e chi se la ritrova in mano alla fine ha perso.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Tutto il resto del mazzo va in mano ai giocatori, a giro: con un mazzo che non si divide esatto qualcuno comincia con una carta in più.",
            "strong": false
          }
        ]
      },
      {
        "kind": "heading",
        "runs": [
          {
            "text": "LE COPPIE",
            "strong": true
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Due carte dello ",
            "strong": false
          },
          {
            "text": "stesso valore",
            "strong": true
          },
          {
            "text": " fanno coppia, ",
            "strong": false
          },
          {
            "text": "di qualunque seme siano",
            "strong": true
          },
          {
            "text": ": due Sette, due Re, due Assi. La coppia si scarta e quelle due carte escono dal gioco per sempre.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Le coppie che si hanno già in mano appena ricevute le carte se ne vanno subito, da sole.",
            "strong": false
          }
        ]
      },
      {
        "kind": "heading",
        "runs": [
          {
            "text": "COME SI GIOCA",
            "strong": true
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "A turno si ",
            "strong": false
          },
          {
            "text": "pesca una carta coperta",
            "strong": true
          },
          {
            "text": " dalla mano del giocatore che viene dopo di te fra quelli ancora in gioco: si sceglie una posizione nel suo ventaglio, senza vedere che carta è. Nessuno può vederla prima, nemmeno chi pesca.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Se la carta pescata fa coppia con una che hai già, ",
            "strong": false
          },
          {
            "text": "la coppia se ne va",
            "strong": true
          },
          {
            "text": " e la tua mano si accorcia; se no la carta ti resta in mano.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Chi rimane ",
            "strong": false
          },
          {
            "text": "senza carte è in salvo",
            "strong": true
          },
          {
            "text": " ed esce dal giro: non pesca più e nessuno pesca più da lui. Può capitare anche a chi si è appena visto portare via l'ultima carta.",
            "strong": false
          }
        ]
      },
      {
        "kind": "heading",
        "runs": [
          {
            "text": "FINE DELLA PARTITA",
            "strong": true
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Si va avanti finché resta ",
            "strong": false
          },
          {
            "text": "un solo giocatore con le carte in mano",
            "strong": true
          },
          {
            "text": ": per forza ha la vecia, ed è lui che perde.",
            "strong": false
          }
        ]
      },
      {
        "kind": "bullet",
        "runs": [
          {
            "text": "Una sola mano decide tutta la partita. Il punteggio è a somma zero: chi perde prende un punto negativo per ogni avversario, tutti gli altri prendono +1.",
            "strong": false
          }
        ]
      }
    ]
  }
]);
